namespace TabAurous.Finance {
    export interface ContraDetailRow {
        TransDetailId?: number;
        TransId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ContraDetailRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Finance.ContraDetail';
        export const deletePermission = 'Finance:Contra:Delete';
        export const insertPermission = 'Finance:Contra:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Contra:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
